import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const ProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2px;
  width: 100%;
`;

export const ProgressBarTrack = styled.div`
  width: 100%;
  height: 6px;
  overflow: hidden;
  box-sizing: border-box;
  ${Styles.BorderStyles}
`;

export const ProgressBarFill = styled.div.attrs(props => ({
  style: {
    width: `${props.percent}%`,
  }
}))`
  height: 100%;
  background-color: ${({ styleProps }) => styleProps.barColor};
`;

export const ProgressBarLabel = styled.span`
  ${Styles.FontStyles}
`;